export default "__VITE_ASSET__DIn3pF2z__"